import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthUserService } from '../service/auth-user-service';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorGuard  {
  constructor(private authUserService: AuthUserService, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    : Promise<boolean> | boolean | Observable<boolean> {
    const isLoggedIn = this.authUserService.isLoggedIn();

    if (isLoggedIn) {
      let lastVisitedRoute = sessionStorage.getItem('lastVisitedRoute');
      if (lastVisitedRoute) {
        lastVisitedRoute = lastVisitedRoute !== '/' ? `/${lastVisitedRoute}` : lastVisitedRoute;
        let path = lastVisitedRoute.split('|')[0];
        if (path === '/' || path === '/content/home' || path === '/content/home/' || '') {
          this.router.navigateByUrl('/workspace').then();
        } else {
          this.router.navigateByUrl(path).then();
        }
      } else {
        this.router.navigateByUrl('/workspace').then();
      }
    }

    return !isLoggedIn;
  }
}
